module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/string.js
// module id = 1027
// module chunks = 1